import { Injectable } from '@angular/core';

import { CallsService } from '@services/api/calls.service';

import { map, Observable } from 'rxjs';

import { 
  StockResponse, 
  StockMovementsResponse, 
  SupplierResponse, 
  LabResponse,
  StockImportDataRequest, 
  StockResponseByCN,
  DeliveryNotesResponse,
  DeliveryNoteItemsResponse
} from '@interfaces/stock';
import { APIResponseParsed } from '@interfaces/api/api.interface';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(
    private calls: CallsService
  ) { }
  
  getStock(): Observable<StockResponse> {
    return this.calls.getStock().pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getStockByCN(cn: string): Observable<StockResponseByCN> {
    return this.calls.getStockByCN(cn).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getStockMovements(cn: string): Observable<StockMovementsResponse> {
    return this.calls.getStockMovements(cn).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getSuppliers(detail?: boolean): Observable<SupplierResponse> {
    return this.calls.getSuppliers(detail).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getLabs(): Observable<LabResponse> {
    return this.calls.getLabs().pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getDeliveryNotes(): Observable<DeliveryNotesResponse> {
    return this.calls.getDeliveryNotes().pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  deleteDeliveryNote(deliveryNoteId: number): Observable<APIResponseParsed> {
    return this.calls.deleteDeliveryNote(deliveryNoteId).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getDeliveryNoteItems(deliveryNoteId: number): Observable<DeliveryNoteItemsResponse> {
    return this.calls.getDeliveryNoteItems(deliveryNoteId).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  modifyStock(cn: string, lote: string, delta: number): Observable<StockResponse> {
    return this.calls.modifyStock(cn, lote, delta).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  registerStock(data: StockImportDataRequest): Observable<StockResponse> {
    return this.calls.registerStock(data).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  insertSupplier(isDistribuidor: boolean, name: string, email: string, telefono: string, observaciones: string): Observable<APIResponseParsed> {
    return this.calls.insertSupplier(isDistribuidor, name, email, telefono, observaciones).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  updateSupplier(distribuidorId: number | null, laboratorioId: number | null, email: string, telefono: string, observaciones: string): Observable<APIResponseParsed> {
    return this.calls.updateSupplier(distribuidorId, laboratorioId, email, telefono, observaciones).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }
}
